let select = document.querySelector('.contact-page .faux-select')

if(select) {
    let inputs = select.querySelectorAll('.faux-select--inputs input')

    inputs.forEach( input => {
        input.addEventListener('change', e => {
            let info = document.querySelector(`[data-type="${e.target.getAttribute('id')}"]`);

            if(info) {
                document.querySelector('.contact-information.active').classList.remove('active')
                info.classList.add('active')
            }

        })
    })

}
